var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import { TextInputFormikField as TextInput } from '../../components/molecules/FormFields/TextInputField';
import { Row, Col } from '../../uikit/grid';
import { inputMasks } from '../../utils/inputMasks.utils';
import { Spacer } from '../../uikit/misc/Spacer';
import { getTranslation } from '../../utils/translations';
import translations from './translations';
import { makePostalAddressSubformModel } from './formModel';
var PATHS = makePostalAddressSubformModel().paths;
var t = getTranslation(translations);
function inNamespace(namespace, fieldName) {
    return "".concat(namespace, ".").concat(fieldName);
}
export var PostalAddressSubForm = function (_a) {
    var namespace = _a.namespace, _b = _a.shouldShowLabels, shouldShowLabels = _b === void 0 ? true : _b, translationsOverride = _a.translationsOverride;
    var translations = useMemo(function () {
        return __assign(__assign({}, t), translationsOverride);
    }, [translationsOverride]);
    var getWordings = function (label, placeholder) { return ({
        label: shouldShowLabels ? label : undefined,
        inputLabel: shouldShowLabels ? undefined : placeholder,
        placeholder: placeholder,
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { sm: 6 },
                React.createElement(TextInput, __assign({ name: inNamespace(namespace, PATHS.POSTAL_CODE), mask: inputMasks.getPostalCodeMask() }, getWordings(translations.postalCodeLabel, t.postalCodePlaceholder)))),
            React.createElement(Col, { sm: 6 },
                React.createElement(TextInput, __assign({ name: inNamespace(namespace, PATHS.CITY) }, getWordings(translations.cityLabel, t.cityPlaceholder))))),
        React.createElement(Row, null,
            React.createElement(Col, { sm: 8 },
                React.createElement(TextInput, __assign({ name: inNamespace(namespace, PATHS.STREET) }, getWordings(translations.streetLabel, t.streetPlaceholder)))),
            React.createElement(Col, { sm: 4 },
                React.createElement(TextInput, __assign({ name: inNamespace(namespace, PATHS.HOUSE_NUMBER) }, getWordings(translations.houseNumberLabel, t.houseNumberPlaceholder))))),
        React.createElement(Spacer, { size: 2 })));
};
